// The ranked product table shared by SF4 and SF5.
//
// Top and bottom performers are the same table read from opposite ends, so the
// columns, the product cell and the growth rendering live here once.
//
// A row is a FAMILY, not a listing: variation children roll up to the parent
// ASIN, so a family whose sales are split across a dozen children ranks on what
// the family earned. The variation count is shown for exactly that reason — a
// row earning more than any single listing would otherwise look wrong.
import React, { useState } from 'react';

import local from '../SalesPerformance.module.css';
import { Change, count, money } from './format';

export const COLUMNS = ['Rank', 'Product', 'Sales', 'Units', 'Growth %'];

// A thumbnail that fails to load falls back to the placeholder box rather than
// leaving a broken image icon in the row.
const ProductCell = ({ row }) => {
  const [broken, setBroken] = useState(false);
  const showImage = row.image_url && !broken;
  return (
    <div className={local.product}>
      {showImage
        ? (
          <img
            className={local.thumb}
            src={row.image_url}
            alt=""
            loading="lazy"
            onError={() => setBroken(true)}
          />
        )
        : <div className={local.thumbEmpty} aria-hidden="true" />}
      <div className={local.productText}>
        <div className={local.productTitle}>{row.title || 'Title not synced'}</div>
        <div className={local.productAsin}>
          {row.asin}
          {row.variation_count > 1 && (
            <span className={local.tileMuted}>
              {` · ${row.variation_count} variations`}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

const SkuRankTable = ({ rows = [], loading, emptyMessage }) => (
  <div className={local.tableScroll}>
    <table className={local.table}>
      <thead>
        <tr>{COLUMNS.map((column) => <th key={column}>{column}</th>)}</tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td className={local.emptyCell} colSpan={COLUMNS.length}>
              {loading ? 'Loading…' : emptyMessage}
            </td>
          </tr>
        ) : rows.map((row) => (
          <tr key={row.asin}>
            <td className={local.rankCell}>{row.rank}</td>
            <td><ProductCell row={row} /></td>
            <td className={local.numeric}>{money(row.revenue)}</td>
            <td className={local.numeric}>{count(row.units)}</td>
            {/* Null growth is absent, not flat. It renders as a dash so a
                product with too little history to compare cannot be read as
                one that held steady. */}
            <td className={local.numeric}><Change value={row.growth} /></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SkuRankTable;
